import React from 'react';
import { Sparkles, CheckCircle, Circle } from 'lucide-react';
import CustomLoader from '../../../../shared/components/ui/CustomLoader';
import { analysisSteps } from '../hooks/useRFPIntake';

const AnalysisProgress = ({
    fetchingGoNoGo,
    goNoGoData,
    filesCount,
    analysisProgress,
    activeStepIndex,
    steps = analysisSteps
}) => {
    return (
        <>
            <div className="scanning-header">
                <div className="scanning-title-box">
                    <div className="scanning-icon-bg"><Sparkles size={24} /></div>
                    <div className="scanning-text">
                        <h2>{goNoGoData ? 'Go / No-Go Decision' : fetchingGoNoGo ? 'Generating Decision...' : 'AI Document Analysis in Progress'}</h2>
                        {!goNoGoData && <p>Processing {filesCount} document{filesCount !== 1 ? 's' : ''}</p>}
                    </div>
                </div>
                {!fetchingGoNoGo && !goNoGoData && <div className="scanning-percent">{analysisProgress}%</div>}
            </div>

            {!fetchingGoNoGo && !goNoGoData && (
                <>
                    <div className="progress-bar-wrapper">
                        <div className="progress-bar-fill" style={{ width: `${analysisProgress}%` }}></div>
                    </div>
                    <div className="scanning-steps-grid">
                        {steps.map((step, idx) => {
                            const isDone = idx < activeStepIndex;
                            const isActive = idx === activeStepIndex;
                            return (
                                <div key={idx} className={`scanning-step-card ${isDone ? 'done' : isActive ? 'active' : 'pending'}`}>
                                    <div className="step-status-icon">
                                        {isDone ? <CheckCircle size={18} className="success-check" /> : 
                                         isActive ? <CustomLoader size={18} className="loader-spin" /> : 
                                         <Circle size={18} className="pending-check" />}
                                    </div>
                                    <div className="step-content-text">
                                        <h4>{step.title}</h4>
                                        <p>{step.desc}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </>
            )}

            {fetchingGoNoGo && (
                <div className="decision-loading-wrapper">
                    <div className="decision-loader-card">
                        <CustomLoader size={48} style={{ margin: '0 auto' }} />
                        <div className="decision-loader-text-stack">
                            <p className="loading-headline">Analyzing Document & Requirements</p>
                            <p className="loading-subtext">Evaluating match criteria for Go / No-Go decision...</p>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AnalysisProgress;
